

















































































import { Component, Emit, Mixins, Prop } from "vue-property-decorator";
import { CalendarEvent } from "@/types";
import PatientMixin from "@/mixins/patientMixin";
import FocusingMixin from "@/mixins/focusingMixin";
import StateButton from "@/components/common_ibow/StateButton.vue";
import { EventType } from "#/model/schedule/calendarType";
import {
  PatientInfo,
  DefaultPatientInfo,
  DefaultReceiptSearchCondition
} from "#/model/receipt";
import { R8_CHANGE_LAW_BASE_YM } from "@/const/common";

@Component({
  components: {
    StateButton
  }
})
export default class ReceiptDetailTitle extends Mixins(
  PatientMixin,
  FocusingMixin
) {
  private readonly r8BaseYM = R8_CHANGE_LAW_BASE_YM;

  /** イベント */
  @Prop({ default: () => [] }) events!: CalendarEvent[];

  /** 利用者 */
  @Prop({ default: () => DefaultPatientInfo() }) patient!: PatientInfo;

  /** 利用者名 */
  @Prop({ default: "" }) patient_name!: string;

  /** 生年月日（和暦） */
  @Prop({ default: "" }) birthday_wareki!: string;

  /** 年齢 */
  @Prop({ default: 0 }) age!: number;

  /** 実績確定日 */
  @Prop({ default: "" }) dateOfResultsDeterminationMedical!: string;
  @Prop({ default: "" }) dateOfResultsDeterminationCare!: string;

  /** 実績確定フラグ */
  @Prop({ default: false }) isDecisionMedical!: boolean;
  @Prop({ default: false }) isDecisionCare!: boolean;

  /** レセプト事前チェック実行日 */
  @Prop({ default: "" }) dateOfPreCheckSameBuilding!: string;
  @Prop({ default: "" }) dateOfPreCheckAccompanied!: string;
  @Prop({ default: "" }) dateOfPreCheckComprehensive!: string;

  /** 利用者情報（確定・未確定） */
  @Prop({ default: "" }) dispDecisionMedical!: string;
  @Prop({ default: "" }) dispDecisionCare!: string;

  /** IDリスト */
  @Prop({ default: () => [] }) ids!: number[];

  /** 利用者ID */
  @Prop({ default: "" }) patientId!: string;

  /** 年月 */
  @Prop({ default: "" }) yearmonth!: string;

  /** 事業所ID */
  @Prop({ default: 0 }) officeId!: number;

  /** 高額療養費が医療保険適用期間内に設定されていないか */
  @Prop({ default: false }) notHighExpense!: boolean;

  /** firestoreに保存するレセプト事前チェックの条件 */
  private condition = DefaultReceiptSearchCondition();

  /** 利用者変更時 */
  @Emit() changePatient() {
    return;
  }

  /** 利用者移動ボタンを表示するかどうか */
  private get IsShowLinkNextDetail() {
    if (this.ids.length === 0) {
      return false;
    } else if (
      this.ids.length === 1 &&
      this.ids[0] === Number(this.patientId)
    ) {
      return false;
    }
    return true;
  }

  /** 前の利用者 */
  private clickLeft() {
    this.changePatientId(false);
  }

  /** 次の利用者 */
  private clickRight() {
    this.changePatientId(true);
  }

  /** 利用者を変更する */
  private changePatientId(isNext: boolean) {
    const id = Number(this.$route.query.id);
    const ids = this.ids;
    const nextId = this.getChangePatientId(isNext, id, ids);

    let movePath = "";
    if (this.$route.query.frompatient) {
      movePath = `/reciept-patient?id=${nextId}&yearmonth=${this.yearmonth}&frompatient=true`;
    } else {
      movePath = `/reciept-patient?id=${nextId}&yearmonth=${this.yearmonth}`;
    }

    this.$router.push({ path: movePath }).then(() => {
      this.changePatient();
    });
  }

  /** 利用者確定状態（確定・未確定） */
  private get dispDecision() {
    let disp = "";
    if (this.HasEventType.isMed) {
      disp += this.dispDecisionMedical;
    }
    if (this.HasEventType.isCare) {
      disp += this.dispDecisionCare;
    }
    return disp;
  }

  private get HasEventType(): { isMed: boolean; isCare: boolean } {
    let isMed = false;
    let isCare = false;
    for (const event of this.events) {
      if (event.type == EventType.Record2Medical) {
        isMed = true;
      }
      if (
        event.type == EventType.Record2NursingCare ||
        event.type == EventType.Record2PassCrawl
      ) {
        isCare = true;
      }
    }
    return { isMed, isCare };
  }

  /** レセプト事前チェック画面を開く */
  private async openPreCheck() {
    this.condition.search_cond.office_id = this.officeId;
    this.condition.search_cond.yearmonth = this.yearmonth;

    // 別タブで利用する値なのでローカルストレージに保存
    localStorage.setItem(
      "PreCheckSelectPatients",
      JSON.stringify([this.patient])
    );
    localStorage.setItem("PreCheckCondition", JSON.stringify(this.condition));

    const route = this.$router.resolve({
      name: "PreCheck"
    });
    window.open(route.href, "_blank");
  }
}
